import Header from "../component/Header";
import TermsTypography from "../component/TermsTypography";
import { Box } from "@mui/system";
import MyBottomNavigation from "../component/MyBottomNavigation";

function Terms(): JSX.Element {

  return (
    <>
      <Header/>
      <Box
        sx={{ p: 3 }}
        display="flex"
        alignItems="start"
        justifyContent="start"
        flexDirection="column"
      >
        <TermsTypography/>
        <Box mt={10}></Box>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        width="100%"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <MyBottomNavigation />
      </Box>      
    </>
  );
};
export default Terms;
